import {WorkspaceItem, WorkspaceItemType} from "@primatoo-ms-organization";
import {PtEntity, PtUiAppRoutes, UiDocumentItem} from "@pt/pt-models";
import {Observable, of} from "rxjs";
import {SubmitDownloadRequest} from "it/primatoo/openapi/api/org/schemas/common/docs/SubmitDownloadRequest";
import {DownloadType} from "it/primatoo/openapi/api/org/schemas/common/docs/DownloadType";
import {DocAccess} from "it/primatoo/openapi/api/org/schemas/common/DocAccess";
import {DocumentItem} from "it/primatoo/openapi/api/org/schemas/common/docs/_listdocumentresponse/DocumentItem";
import {TreatmentType} from "it/primatoo/openapi/api/org/schemas/treatmentdoc/TreatmentType";
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

export class DocumentItemUtils {
  static getResourceType(subType: string): WorkspaceItemType {
    return subType as WorkspaceItemType;
  }


  static getColumnsEnabledAndDocId(documentColsEnabled: ColumnWithLocalization[], required: string[]): string[] {
    const out: string[] = documentColsEnabled.filter(c => c.uiUserShow).map(c => c.column);
    if (required && required.length > 0) {
      required.forEach((c) => {
        if (!out.includes(c)) {
          out.push(c);
        }
      })
    }
    return out;
  }

  static convertDocument(document: DocumentItem, docAccess: DocAccess = DocAccess.FULL): UiDocumentItem | undefined {
    const doc = (document as any);

    switch (true) {
      case doc === null || doc === undefined:
        console.error('Invalid global measure ', doc);
        return undefined;
      case doc.docId === null || doc.docId === undefined:
        console.error('Invalid global measure. Missing docId ', doc);
        return undefined;
      // case doc.name === null || doc.name === undefined:
      //   console.error('Invalid global measure. Missing name ', doc);
      //   return undefined;
      default: {
        const response: UiDocumentItem = {
          docId: doc.docId,
          name: doc.name,
          status: doc.status,
          creatorUserId: doc.creatorUserId,
          treatmentType: doc.treatmentType,
          docAccess: doc.docAccess || docAccess,
          parentId: doc.parentId,
          description: doc.description
        }
        return response
      }
    }

  }


  static createDocumentItem(
    docId: number,
    name: string,
    creatorUserId: number,
    status: any,
    docAccess: DocAccess = DocAccess.FULL,
    parentId: number,
    treatmentType?: TreatmentType,
    treatmentCategoryId?: number
  ): UiDocumentItem {
    return {
      docId,
      name,
      creatorUserId,
      status,
      docAccess,
      treatmentType,
      parentId,
      description: '',
      treatmentCategoryId
    }
  }

  static fromWorkspaceItem(item: WorkspaceItem): UiDocumentItem {
    return {
      docId: item.id,
      name: item.name,
      status: undefined,
      creatorUserId: undefined,
      docAccess: DocAccess.READ_ONLY,
      parentId: item.parentId,
      description: '',
    }
  }

  public static checkDownloadDoc(items: Array<UiDocumentItem>): Observable<SubmitDownloadRequest | any> {
    if (items?.length === 1) {
      return this.checkMissingPermissionSingle(items[0]);
    }

    if (items?.length > 1) {
      return this.checkMissingPermissionMulti(items);
    }
    return of(false);
  }

  private static checkMissingPermissionSingle(item: UiDocumentItem) {
    return new Observable<SubmitDownloadRequest | null>((obs) => {
      obs.next({
        downloadType: DownloadType.PDF,
        chapterSelectors: [],
        ids: [item.docId]
      })
    });
  }

  private static checkMissingPermissionMulti(items: Array<UiDocumentItem>) {
    return new Observable<SubmitDownloadRequest | null>((obs) => {
      if (items?.length === 1) {
        obs.next({
          downloadType: DownloadType.PDF,
          ids: [items[0].docId]
        });
      } else {
        obs.next({
          downloadType: DownloadType.ZIP,
          ids: items.map((i) => i.docId)
        });
      }
    });
  }

  static getPtEntity(treatmentType?: TreatmentType): PtEntity | undefined {
    switch (treatmentType) {
      case TreatmentType.HOLDER:
        return 'treatmentsHolder';
      case TreatmentType.PROJECT:
        return 'projectCards';
      case TreatmentType.RESPONSIBLE:
        return 'treatmentsResponsible';
      case TreatmentType.SUB_RESPONSIBLE:
        return 'treatmentsSubResponsible';
    }
    return undefined;
  }
}
